import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
const TagList = (props) => {
    const { children, inline = true, autoTagWidth = false, tagsPerRow } = props, remainingProps = __rest(props, ["children", "inline", "autoTagWidth", "tagsPerRow"]);
    const tagListClasses = classNames('taglist', !autoTagWidth && 'taglist-autowidth', !inline && 'taglist-vertical', tagsPerRow && 'row display-flex-sm flex-wrap-sm', props.className);
    const wrappedChildren = _jsx("div", Object.assign({ className: `tags-per-row-${tagsPerRow}` }, { children: children }));
    return (_jsx("div", Object.assign({}, remainingProps, { className: tagListClasses }, { children: tagsPerRow ? wrappedChildren : children })));
};
export default TagList;
